export default "./dist/stdassets/images/res/sliderscale.png";